import { generate } from '@ant-design/colors';

const PRIMARY_COLOR = '#3498DB';
const colorsPallet = generate(PRIMARY_COLOR);

let COLORS: {
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
  color6: string;
  color7: string;
  color8: string;
  color9: string;
} = {
  color1: '',
  color2: '',
  color3: '',
  color4: '',
  color5: '',
  color6: '',
  color7: '',
  color8: '',
  color9: ''
};

colorsPallet.forEach((color, index) => (COLORS[`color${index + 1}`] = color));

export { COLORS, PRIMARY_COLOR };
